class FacetShort extends HTMLSelectElement {
  constructor() {
    super();
    this.initMotionInView();
    this.addEventListener('change', this.onSelectChange.bind(this));
  }

  get options() {
    return this.getElementsByTagName('option');
  }

  get fakeSelectElement() {
    return this.previousElementSibling;
  }

  initMotionInView() {
    FoxTheme.Motion.inView(this, this.calcSelectWidth.bind(this), { margin: '200px 0px 200px 0px' });
  }

  calcSelectWidth() {
    const selectStyle = window.getComputedStyle(this);
    const selectedOptionText = this.options[this.selectedIndex].text;

    const textElement = this.createTextElement(selectedOptionText, selectStyle);
    document.body.appendChild(textElement);
    const selectWidth = textElement.offsetWidth;
    textElement.remove();

    this.style.setProperty('--width', `${selectWidth + 22}px`);
  }

  createTextElement(text, style) {
    const textElement = document.createElement('span');
    textElement.style.fontFamily = style.fontFamily;
    textElement.style.fontSize = style.fontSize;
    textElement.style.fontWeight = style.fontWeight;
    textElement.style.visibility = 'hidden';
    textElement.style.position = 'absolute';
    textElement.innerHTML = text;
    return textElement;
  }

  onSelectChange(event) {
    this.calcSelectWidth();
    this.updateFormParams(event);
  }

  updateFormParams(event) {
    const form = this.getClosestFacetForm() || this.getFirstFacetForm();

    if (form) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.set('section_id', FoxTheme.utils.getSectionId(form));
      url.searchParams.delete('page');
      form.renderSection(url.toString(), event);
    }
  }

  getClosestFacetForm() {
    return this.closest('form[is="facet-form"]');
  }

  getFirstFacetForm() {
    return document.querySelector('form[is="facet-form"]');
  }
}
customElements.define('facet-short', FacetShort, { extends: 'select' });

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.minRangeInput = this.querySelector('input[type="range"]:first-child');
    this.maxRangeInput = this.querySelector('input[type="range"]:last-child');
    this.minPriceInput = this.querySelector('input[name="filter.v.price.gte"]');
    this.maxPriceInput = this.querySelector('input[name="filter.v.price.lte"]');

    this.minPriceInput.addEventListener('focus', this.minPriceInput.select);
    this.maxPriceInput.addEventListener('focus', this.maxPriceInput.select);
    this.minPriceInput.addEventListener('change', this.handleInputMinChange.bind(this));
    this.maxPriceInput.addEventListener('change', this.handleInputMaxChange.bind(this));

    this.minRangeInput.addEventListener('change', this.handleRangeMinChange.bind(this));
    this.maxRangeInput.addEventListener('change', this.handleRangeMaxChange.bind(this));
    this.minRangeInput.addEventListener('input', this.handleRangeMinInput.bind(this));
    this.maxRangeInput.addEventListener('input', this.handleRangeMaxInput.bind(this));
  }

  handleInputMinChange(event) {
    event.preventDefault();
    event.target.value = Math.max(
      Math.min(parseInt(event.target.value), parseInt(this.maxPriceInput.value || event.target.max) - 1),
      event.target.min
    );
    this.minRangeInput.value = event.target.value;
    this.minRangeInput.parentElement.style.setProperty(
      '--range-min',
      `${(parseInt(this.minRangeInput.value) / parseInt(this.minRangeInput.max)) * 100}%`
    );
  }

  handleInputMaxChange(event) {
    event.preventDefault();
    event.target.value = Math.min(
      Math.max(parseInt(event.target.value), parseInt(this.minPriceInput.value || event.target.min) + 1),
      event.target.max
    );
    this.maxRangeInput.value = event.target.value;
    this.maxRangeInput.parentElement.style.setProperty(
      '--range-max',
      `${(parseInt(this.maxRangeInput.value) / parseInt(this.maxRangeInput.max)) * 100}%`
    );
  }

  handleRangeMinChange(event) {
    event.stopPropagation();
    this.minPriceInput.value = event.target.value;
    this.minPriceInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  handleRangeMaxChange(event) {
    event.stopPropagation();
    this.maxPriceInput.value = event.target.value;
    this.maxPriceInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  handleRangeMinInput(event) {
    event.target.value = Math.min(
      parseInt(event.target.value),
      parseInt(this.maxPriceInput.value || event.target.max) - 1
    );
    event.target.parentElement.style.setProperty(
      '--range-min',
      `${(parseInt(event.target.value) / parseInt(event.target.max)) * 100}%`
    );
    this.minPriceInput.value = event.target.value;
  }

  handleRangeMaxInput(event) {
    event.target.value = Math.max(
      parseInt(event.target.value),
      parseInt(this.minPriceInput.value || event.target.min) + 1
    );
    event.target.parentElement.style.setProperty(
      '--range-max',
      `${(parseInt(event.target.value) / parseInt(event.target.max)) * 100}%`
    );
    this.maxPriceInput.value = event.target.value;
  }
}
customElements.define('price-range', PriceRange);

/* ============================================================================
   CASEMIRA · CHANTIER 8, VAGUE 4B · LES GROUPES DE FACETTES DIFFERES
   ----------------------------------------------------------------------------
   CE QUE CA FAIT. Les groupes du TIROIR de facettes qui ne portent aucune valeur
   active sont livres par Liquid dans un `<template>` inerte, pose DANS leur div
   de contenu. Ils ne comptent alors ni dans le DOM, ni dans les recalculs de
   style, ni dans les `querySelectorAll` du document. Le clone est fabrique a la
   premiere ouverture du tiroir ou du groupe.

   TROIS CONTRAINTES ONT DICTE CETTE FORME, ET AUCUNE N'EST NEGOCIABLE.

   1. AUCUN FILTRE NE PEUT ETRE PERDU. `buildUrl()` construit l'adresse par
      `new URLSearchParams(new FormData(this))` : un champ absent du document est
      un filtre perdu. Liquid ne differe donc QUE les groupes sans valeur active,
      qui ne contribuent rien a `FormData`. En seconde barriere, `onFormSubmit`
      deploie tout le formulaire AVANT de construire l'adresse : meme si la
      condition Liquid etait un jour fausse, le filtre partirait quand meme.

   2. LE `<template>` EST DANS LE DIV DE CONTENU, JAMAIS A SA PLACE.
      `assets/theme.js` (AccordionDetails) retient `summary + *` a la
      construction, et `facets.js` recopie `summary + *`.innerHTML a chaque
      re-rendu (`renderFilters`). Si le `<template>` prenait la place du div,
      l'accordeon perdrait son contenu et le re-rendu ecraserait le gabarit.
      Avec le `<template>` a l'interieur, le re-rendu recopie AUSSI le gabarit,
      avec ses compteurs a jour - c'est le point dur du plan, et il est resolu
      par la structure et non par du code.

   3. LE RE-RENDU REMET LE GROUPE A L'ETAT DIFFERE. `cmRearmerFacettes()` est donc
      rappelee a la fin de `renderFilters()`, et reconstruit le clone des SEULS
      groupes que l'utilisateur avait deja deployes.

   Ce qui n'est PAS touche : la barre de collection C6 (`#FacetFiltersContainer`,
   `form.cmc__groups`), que les chips et les tuiles interrogent par
   `form.querySelectorAll('input[name=...]')` - un `querySelectorAll` ne voit pas
   le contenu d'un `<template>`, differer la barre casserait ces gestes. Et la
   colonne `vertical` de la page recherche, visible sans clic.
   ========================================================================== */
const CM_HOTE_DIFFERE = '[data-cm-differe]';
const cmGroupesDeployes = new Set();
let cmTiroirObserve = false;

function cmCleGroupe(hote) {
  const details = hote && typeof hote.closest === 'function' ? hote.closest('details[data-filter]') : null;
  return details ? details.getAttribute('data-index') || '' : '';
}

/* Idempotente : un hote deja deploye porte plus d'un enfant, on ne refait rien. */
function cmDeployerHote(hote) {
  const gabarit = hote.querySelector(':scope > template[data-cm-facette]');
  if (!gabarit) return false;

  const cle = cmCleGroupe(hote);
  if (cle) cmGroupesDeployes.add(cle);
  if (hote.children.length > 1) return false;

  hote.appendChild(gabarit.content.cloneNode(true));
  return true;
}

function cmDeployerFacettes(racine) {
  const zone = racine && typeof racine.querySelectorAll === 'function' ? racine : document;
  let n = 0;
  zone.querySelectorAll(CM_HOTE_DIFFERE).forEach((hote) => {
    if (cmDeployerHote(hote)) n++;
  });
  /* Le meme hote peut etre la racine (cas du `<details>` clique). */
  if (zone.matches && zone.matches(CM_HOTE_DIFFERE) && cmDeployerHote(zone)) n++;
  if (n) document.dispatchEvent(new CustomEvent('casemira:facettes-deployees'));
  return n;
}

function cmRearmerFacettes() {
  let n = 0;
  document.querySelectorAll(CM_HOTE_DIFFERE).forEach((hote) => {
    const cle = cmCleGroupe(hote);
    if (!cle || !cmGroupesDeployes.has(cle)) return;
    if (cmDeployerHote(hote)) n++;
  });
  if (n) document.dispatchEvent(new CustomEvent('casemira:facettes-deployees'));
  return n;
}

/* Le clic est ecoute en phase de CAPTURE, donc AVANT le gestionnaire du tiroir et
   avant celui du `<summary>` pose par AccordionDetails : le contenu est en place
   quand l'accordeon mesure `scrollHeight` pour son animation, et le tiroir n'est
   jamais peint vide. */
document.addEventListener(
  'click',
  (event) => {
    const cible = event.target;
    if (!cible || typeof cible.closest !== 'function') return;

    const bouton = cible.closest('[aria-controls]');
    if (bouton) {
      const id = bouton.getAttribute('aria-controls') || '';
      if (id.indexOf('Facet') !== -1) {
        cmDeployerFacettes(document.getElementById(id) || document);
        return;
      }
    }

    const resume = cible.closest('summary');
    if (resume && resume.parentElement && resume.parentElement.matches('details[data-filter]')) {
      cmDeployerFacettes(resume.parentElement);
    }
  },
  true
);

/* Filet : le tiroir peut etre ouvert sans clic (`drawer.show()` de
   casemira-collection.js). Un MutationObserver sur `hidden` rend la main avant
   la peinture, la callback etant une micro-tache. */
function cmSurveillerTiroir() {
  if (cmTiroirObserve) return;
  const tiroir = document.getElementById('FacetDrawer');
  if (!tiroir) return;
  cmTiroirObserve = true;
  new MutationObserver(() => {
    if (!tiroir.hasAttribute('hidden')) cmDeployerFacettes(tiroir);
  }).observe(tiroir, { attributes: true, attributeFilter: ['hidden'] });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', cmSurveillerTiroir);
} else {
  cmSurveillerTiroir();
}

class FacetForm extends HTMLFormElement {
  constructor() {
    super();

    this.dirty = false;
    this.cachedMap = new Map();

    this.addEventListener('change', this.onFormChange);
    this.addEventListener('submit', this.onFormSubmit);
  }

  onFormChange() {
    this.dirty = true;
    this.dispatchEvent(new Event('submit', { cancelable: true }));
  }

  onFormSubmit(event) {
    event.preventDefault();
    if (!this.dirty) return;

    /* CASEMIRA C8 vague 4b · seconde barriere : tout groupe encore differe est
       deploye AVANT `buildUrl()`. Un groupe differe n'a par construction aucune
       case cochee, donc l'adresse produite est identique - mais si la condition
       Liquid etait un jour fausse, le filtre partirait quand meme. */
    cmDeployerFacettes(this);

    const url = this.buildUrl().toString();
    this.renderSection(url, event);
  }

  buildUrl() {
    const searchParams = new URLSearchParams(new FormData(this));
    const url = new URL(this.action);

    url.search = '';
    searchParams.forEach((value, key) => url.searchParams.append(key, value));

    ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach((item) => {
      if (url.searchParams.get(item) === '') {
        url.searchParams.delete(item);
      }
    });

    url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this));
    return url;
  }

  updateURLHash(url) {
    const clonedUrl = new URL(url);
    clonedUrl.searchParams.delete('section_id');
    history.replaceState({}, '', clonedUrl.toString());
  }

  /* CASEMIRA C3 (vague 1) : la barre de filtres desktop pose `data-cmc-bar` sur <html>.
     Quand elle est active, la grille ne saute plus de 50 px et ne s'efface plus d'un coup :
     elle sort en fondu de 150 ms et rentre en 250 ms, sans cascade carte par carte, et
     casemira-collection.js replace au passage (FLIP) les cartes qui survivent au filtre. */
  get casemiraBar() {
    return document.documentElement.hasAttribute('data-cmc-bar');
  }

  beforeRenderSection() {
    const container = document.getElementById('ProductGridContainer');
    const loadings = document.querySelectorAll('[data-facet-loading]');
    const casemiraBar = this.casemiraBar;
    const translateY = FoxTheme.config.motionReduced || casemiraBar ? 0 : 50;

    if (casemiraBar) {
      document.dispatchEvent(new CustomEvent('collection:beforererender'));
      FoxTheme.Motion.timeline([
        [container, { opacity: 0 }, { duration: FoxTheme.config.motionReduced ? 0 : 0.15, easing: [0.2, 0.7, 0.2, 1] }],
      ]);
    } else {
      FoxTheme.Motion.timeline([[container, { y: translateY, opacity: 0 }, { duration: 0 }]]);
    }

    /* CASEMIRA: aucun scroll ici. La décision de scroller est prise dans afterRenderSection(),
       une fois la nouvelle grille en place : mesurée ici, la géométrie serait celle de
       l'ANCIENNE grille (encore haute), et un filtre qui réduit la sélection à quelques
       produits laisserait l'utilisateur sous la grille raccourcie, écran vide. */

    /* CASEMIRA: on garde le délai de 100 ms (pas de clignotement du bouton si la réponse est
       immédiate) MAIS on mémorise le timer : le rendu pouvant désormais arriver en moins de
       100 ms, afterRenderSection() doit pouvoir l'annuler, sinon la classe serait posée APRÈS
       son retrait et les boutons resteraient bloqués en état de chargement. */
    this.loadingStateTimeout = setTimeout(() => {
      this.loadingStateTimeout = null;
      if (loadings) {
        loadings.forEach((loading) => {
          loading.classList.add('btn--loading');
        });
      }
    }, 100);
  }

  afterRenderSection() {
    const container = document.getElementById('ProductGridContainer');
    const items = container.querySelectorAll('.product-card');
    const loadings = document.querySelectorAll('[data-facet-loading]');
    const casemiraBar = this.casemiraBar;
    const translateY = FoxTheme.config.motionReduced || casemiraBar ? 0 : 50;

    /* CASEMIRA: scroll conditionnel, mesuré sur la NOUVELLE grille.

       DÉCLENCHEMENT (inchangé) : on cible #ProductGridContainer et pas .collection : la
       sidebar de filtres garde .collection haute même avec 8 produits, le test de visibilité
       serait faussé. On ne bouge QUE si la grille est entièrement hors de l'écran
       (l'utilisateur ne verrait aucun résultat) ; sinon on conserve sa position de lecture.
       Le container porte encore le translateY posé par beforeRenderSection : on raisonne
       donc sur sa position finale, une fois l'animation retombée à y = 0.

       DESTINATION : on ne vise plus « haut de la grille − 200 px ». Ce point atterrissait
       DERRIÈRE les deux éléments sticky qui se ré-épinglent en haut de l'écran (le header,
       puis la barre d'outils « Filtrer | N produits ») : le haut des images de la 1re rangée
       était coupé, et la rangée de chips (#QuickFilters), placée AU-DESSUS de la grille,
       restait hors écran. On vise maintenant le premier élément NON sticky du bloc de
       filtres, et on réserve au-dessus de lui la hauteur réellement masquée par le sticky.
       À l'arrivée on voit donc, de haut en bas : barre d'outils, filtres actifs, chips,
       puis la 1re rangée de produits entière. */
    let scrollDelta = 0;
    if (container) {
      const rect = container.getBoundingClientRect();
      const settledTop = rect.top - translateY;
      const settledBottom = rect.bottom - translateY;

      if (settledBottom < 0 || settledTop > window.innerHeight) {
        /* Cible, du plus haut au plus bas : pastilles de filtres actifs, puis chips, puis la
           grille en repli (page recherche, ou collection sans chips). Les candidats vides sont
           ignorés (offsetHeight 0) : #FacetFiltersActive est toujours rendu mais vide tant
           qu'aucun filtre n'est actif, et #QuickFilters peut ne contenir aucun chip.
           On n'utilise volontairement AUCUN élément sticky comme cible : son
           getBoundingClientRect() renvoie la position ÉPINGLÉE, pas la position naturelle. */
        const scrollAnchor =
          [document.getElementById('FacetFiltersActive'), document.getElementById('QuickFilters'), container].find(
            (element) => element && element.offsetHeight > 0
          ) || container;

        /* Seul #ProductGridContainer porte le translateY de beforeRenderSection(). */
        const anchorTranslateY = scrollAnchor === container ? translateY : 0;
        const anchorTop = scrollAnchor.getBoundingClientRect().top - anchorTranslateY + window.scrollY;

        /* Hauteur masquée en haut de l'écran à l'arrivée = header ré-épinglé + barre d'outils
           sticky, qu'il faut donc réserver au-dessus de la cible.

           Le `top` de la barre d'outils dépend de l'état du header AU MOMENT du clic :
           négatif (barre remontée hors écran) tant que le header est masqué, 18rem = 180 px
           en desktop / 10rem = 100 px en mobile dès que body.header-pinned est posé
           (surcharge CASEMIRA dans main-collection-product-grid.liquid ; le thème, lui,
           utilise --header-height, cf. .sticky-element dans theme.css). Or notre remontée
           REPINGLE le header pendant le scroll : lire le `top` courant sous-estimerait
           l'offset et la barre viendrait recouvrir la cible à l'arrivée.
           On raisonne donc sur --header-height (posée par header.js : 142 px desktop /
           71 px mobile, mesuré) + une garde de 40 px qui couvre l'écart constaté avec la
           valeur épinglée (180 − 142 = 38 px desktop, 100 − 71 = 29 px mobile), et on garde
           le max avec le `top` courant au cas où il serait déjà plus bas. Résultat :
           destination identique que le header soit épinglé ou non au moment du clic. */
        const headerHeight =
          parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const toolbar = document.querySelector('.collection__toolbar');
        const toolbarSticky = toolbar ? toolbar.closest('.sticky-element') : null;
        const toolbarStickyTop = toolbarSticky ? parseFloat(getComputedStyle(toolbarSticky).top) || 0 : 0;
        const toolbarHeight = toolbarSticky ? toolbarSticky.offsetHeight : 0;
        const pinnedHeaderGuard = 40;
        /* + 16 px : marge esthétique, la cible ne colle pas à la barre d'outils. */
        const stickyOffset =
          Math.max(headerHeight + pinnedHeaderGuard, toolbarStickyTop, 0) + toolbarHeight + 16;

        const maxScrollY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
        const targetScrollY = Math.min(Math.max(0, anchorTop - stickyOffset), maxScrollY);

        /* scrollDelta doit rester la destination RÉELLEMENT visée (bornée au document) :
           c'est lui qui sert plus bas à partitionner les cartes à animer. */
        scrollDelta = targetScrollY - window.scrollY;
        window.scrollTo({
          top: targetScrollY,
          behavior: FoxTheme.config.motionReduced ? 'auto' : 'smooth',
        });
      }
    }

    /* CASEMIRA: n'animer (stagger) que les cartes que l'utilisateur a réellement sous les yeux.
       Avec 36 cartes staggerées à 0,1 s, la 30e attendait ~3 s en visibility:hidden : depuis le
       milieu de la grille, les cartes visibles étaient les DERNIÈRES à apparaître, d'où
       l'impression que la page « se charge par le bas ». Les autres sont rendues visibles
       immédiatement. La partition est calculée à la position d'ARRIVÉE du scroll ci-dessus
       (rect corrigé du scrollDelta), sinon on animerait des cartes hors écran. */
    const viewportMargin = 200;
    const animatedItems = [];

    /* CASEMIRA C3 : avec la barre desktop, aucune carte n'est mise en retrait — donc
       aucune mesure de géométrie à faire ici non plus, et la partition est sautée. */
    if (!casemiraBar) items.forEach((item) => {
      const itemRect = item.getBoundingClientRect();
      const itemTop = itemRect.top - translateY - scrollDelta;
      const itemBottom = itemRect.bottom - translateY - scrollDelta;
      const isInView = itemBottom > -viewportMargin && itemTop < window.innerHeight + viewportMargin;

      if (isInView) {
        animatedItems.push(item);
      } else {
        /* Aucune carte ne doit rester en visibility:hidden : on pose les styles en dur
           puisque ces cartes ne passent pas par le timeline. */
        item.style.opacity = '1';
        item.style.visibility = 'visible';
      }
    });

    const timelineSequence = casemiraBar
      ? [
          [
            container,
            { opacity: [0, 1] },
            { duration: FoxTheme.config.motionReduced ? 0 : 0.25, easing: [0.2, 0.7, 0.2, 1] },
          ],
        ]
      : [[container, { y: [translateY, 0], opacity: [0, 1] }]];

    if (animatedItems.length > 0) {
      timelineSequence.push([
        animatedItems,
        { y: [translateY, 0], opacity: [0, 1], visibility: ['hidden', 'visible'] },
        { duration: 0.5, delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion.stagger(0.1) },
      ]);
    }

    FoxTheme.Motion.timeline(timelineSequence);

    /* CASEMIRA: annule la pose différée de btn--loading si le rendu a été plus rapide qu'elle. */
    if (this.loadingStateTimeout) {
      clearTimeout(this.loadingStateTimeout);
      this.loadingStateTimeout = null;
    }

    if (loadings) {
      loadings.forEach((loading) => {
        loading.classList.remove('btn--loading');
      });
    }

    document.dispatchEvent(new CustomEvent('collection:rerendered'));
  }

  renderSection(url, event) {
    /* CASEMIRA: masquer les produits épuisés quand un filtre dimension est actif */
    var _u = new URL(url, window.location.origin);
    if (_u.searchParams.has('filter.v.option.taille')) {
      _u.searchParams.set('filter.v.availability', '1');
    } else {
      _u.searchParams.delete('filter.v.availability');
    }
    url = _u.toString();

    /* CASEMIRA C3 (vague 5) : l'URL est réécrite AVANT que la réponse arrive. Si le
       rendu échoue, la grille reste celle d'avant : l'adresse décrirait alors une
       sélection qui n'est pas à l'écran. On garde donc de quoi la remettre. */
    this.urlBeforeRender = window.location.href;

    this.cachedMap.has(url) ? this.renderSectionFromCache(url, event) : this.renderSectionFromFetch(url, event);

    if (this.hasAttribute('data-history')) this.updateURLHash(url);

    this.dirty = false;
  }

  /* CASEMIRA C3 (vague 5) : la garde qui manquait.

     Le code d'origine ne regardait jamais si sa requête avait abouti : il faisait
     `container.innerHTML = source && source.innerHTML`, donc `null` quand la réponse
     était une page d'erreur - et le conteneur de filtres se VIDAIT. Quand Shopify
     bride le rendu de section (503) ou que Cloudflare pose un défi (429), la barre de
     l'ordinateur disparaissait, et sur téléphone c'était la feuille ouverte qui
     s'évanouissait sous le doigt. Relevé en vague 2 (§ 6 bis), corrigé ici.

     Deux tests, pas un : le statut HTTP, et la présence de `#ProductGridContainer`
     dans le HTML reçu. Le second attrape le cas où un intermédiaire répond 200 avec
     une page qui n'est pas la section (défi Cloudflare, page de maintenance).

     En échec, on ne touche à RIEN : pas de rendu, pas de vidage, pas de changement
     d'URL. On rend seulement la grille visible (beforeRenderSection l'avait mise à
     zéro) et on diffuse `collection:renderfailed` avec l'URL, que
     casemira-collection-more.js transforme en « Réessayer » dans le pied de la barre
     ou de la feuille. Le même événement sert aux deux mondes. */
  failRenderSection(url, error) {
    if (this.loadingStateTimeout) {
      clearTimeout(this.loadingStateTimeout);
      this.loadingStateTimeout = null;
    }

    document.querySelectorAll('[data-facet-loading]').forEach((loading) => {
      loading.classList.remove('btn--loading');
    });

    const container = document.getElementById('ProductGridContainer');
    if (container) {
      /* beforeRenderSection() a posé, selon le monde, `opacity: 0` (barre C3) ou
         `opacity: 0` + `y: 50` (thème d'origine). Les deux sont des styles en ligne
         posés par Motion : les effacer suffit à revenir à l'état de repos. */
      container.style.opacity = '';
      container.style.transform = '';
      /* Motion pose ses valeurs par une animation WAAPI en `fill` : effacer le
         style en ligne ne suffit pas toujours à défaire un `opacity: 0`. On
         repose donc explicitement l'état de repos, en durée nulle. */
      FoxTheme.Motion.timeline([[container, { opacity: 1, y: 0 }, { duration: 0 }]]);
    }

    /* L'adresse redit ce que la grille montre encore. */
    if (this.urlBeforeRender && this.urlBeforeRender !== window.location.href) {
      history.replaceState({}, '', this.urlBeforeRender);
    }

    document.dispatchEvent(
      new CustomEvent('collection:renderfailed', {
        detail: { url: url, message: error && error.message ? error.message : '' },
      })
    );
  }

  renderSectionFromFetch(url, event) {
    this.beforeRenderSection();

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then((responseText) => {
        /* CASEMIRA: plus de plancher artificiel de 250 ms — les résultats s'affichent dès que
           la réponse est là. Et la réponse (~1 Mo) n'est parsée QU'UNE FOIS : chaque méthode
           render* refaisait son propre DOMParser, soit 7 parsings complets par rendu. */
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

        if (parsedHTML.getElementById('ProductGridContainer') === null) {
          throw new Error('rendu incomplet');
        }

        setTimeout(() => {
          this.renderFilters(parsedHTML, event);
          this.renderFiltersActive(parsedHTML);
          this.renderProductGridContainer(parsedHTML);
          this.renderFacetFiltersContainer(parsedHTML);
          this.renderProductCount(parsedHTML);
          this.renderSortBy(parsedHTML);
          this.renderSortByMobile(parsedHTML);

          /* Le pubsub continue de diffuser le TEXTE brut : contrat inchangé pour les abonnés
             (facet-count et tout autre composant du thème). */
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, { responseText: responseText });
          this.cachedMap.set(url, responseText);

          this.afterRenderSection();
        }, 0);
      })
      .catch((error) => this.failRenderSection(url, error));
  }

  renderSectionFromCache(url, event) {
    this.beforeRenderSection();

    /* CASEMIRA: données déjà en mémoire — aucune raison d'attendre 250 ms de plus. */
    setTimeout(() => {
      const responseText = this.cachedMap.get(url);
      const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');

      this.renderFilters(parsedHTML, event);
      this.renderFiltersActive(parsedHTML);
      this.renderProductGridContainer(parsedHTML);
      this.renderFacetFiltersContainer(parsedHTML);
      this.renderProductCount(parsedHTML);
      this.renderSortBy(parsedHTML);
      this.renderSortByMobile(parsedHTML);

      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, { responseText: responseText });

      this.afterRenderSection();
    }, 0);
  }

  renderFilters(parsedHTML, event) {
    const facetElements = parsedHTML.querySelectorAll(
      '#FacetFiltersContainer [data-filter], #MobileFacetFiltersContainer [data-filter], #DrawerFacetFiltersContainer [data-filter]'
    );

    const facetElementsFormDom = document.querySelectorAll(
      '#FacetFiltersContainer [data-filter], #MobileFacetFiltersContainer [data-filter], #DrawerFacetFiltersContainer [data-filter]'
    );

    Array.from(facetElementsFormDom).forEach((currentElement) => {
      if (!Array.from(facetElements).some(({ id }) => currentElement.id === id)) {
        currentElement.classList.add('hidden');
      }
    });

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('[data-filter]') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetElements).filter((element) => !matchesIndex(element));

    facetsToRender.forEach((element) => {
      const filter = document.querySelector(`[data-filter][data-index="${element.dataset.index}"]`);
      if (filter !== null) {
        filter.classList.remove('hidden');
        if (filter.tagName === 'DETAILS') {
          filter.querySelector('summary + *').innerHTML = element.querySelector('summary + *').innerHTML;
        } else {
          filter.innerHTML = element.innerHTML;
        }
      }
    });

    /* CASEMIRA C8 vague 4b · la ligne ci-dessus vient de remettre les groupes
       differes a l'etat « gabarit seul », avec des compteurs a jour. On
       reconstruit le clone des seuls groupes deja ouverts par l'utilisateur. */
    cmRearmerFacettes();
  }

  renderFiltersActive(parsedHTML) {
    const id = 'FacetFiltersActive';
    if (document.getElementById(id) === null) return;

    document.getElementById(id).innerHTML = parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;
  }

  renderProductGridContainer(parsedHTML) {
    const id = 'ProductGridContainer';
    if (document.getElementById(id) === null) return;

    document.getElementById(id).innerHTML = parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;

    const layoutSwitcher = document.querySelector('layout-switcher');
    if (layoutSwitcher) layoutSwitcher.onButtonClick(layoutSwitcher.querySelector('.btn--active'));
  }

  /* CASEMIRA: identifiant stable d'un bloc de filtre, pour retrouver le même bloc entre
     l'ancien et le nouveau HTML. data-index en priorité, texte du summary en secours. */
  getFacetKey(details) {
    if (details.dataset && details.dataset.index) return details.dataset.index;

    const summary = details.querySelector('summary');
    return summary ? summary.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
  }

  renderFacetFiltersContainer(parsedHTML) {
    const id = 'FacetFiltersContainer';
    const container = document.getElementById(id);
    if (container === null) return;

    /* CASEMIRA: ce container (sidebar desktop) est remplacé EN ENTIER, ce qui détruit les
       <details> et fait retomber les accordéons sur le défaut Liquid — Prix et Dimensions
       étant fermés par défaut, le bloc se refermait dès qu'on saisissait le prix min.
       On relève donc l'état réel (ouvert ET fermé) avant remplacement, et on le réapplique
       DANS le HTML source AVANT insertion : poser l'attribut après coup déclencherait
       l'animation d'ouverture du custom element accordion-details. L'état choisi par
       l'utilisateur prime toujours sur le défaut Liquid.
       Le tiroir mobile (#DrawerFacetFiltersContainer) n'est pas concerné : renderFilters()
       ne remplace que le contenu des <details> existants, ses accordéons survivent déjà. */
    const openStates = new Map();
    container.querySelectorAll('details[data-filter]').forEach((details) => {
      const key = this.getFacetKey(details);
      if (key) openStates.set(key, details.hasAttribute('open'));
    });

    const source = parsedHTML.getElementById(id);

    if (source) {
      source.querySelectorAll('details[data-filter]').forEach((details) => {
        const key = this.getFacetKey(details);
        if (!openStates.has(key)) return;

        if (openStates.get(key)) {
          details.setAttribute('open', '');
        } else {
          details.removeAttribute('open');
        }
      });
    }

    container.innerHTML = source && source.innerHTML;
  }

  renderProductCount(parsedHTML) {
    const id = 'ProductCount';
    if (document.getElementById(id) === null) return;

    document.getElementById(id).innerHTML = parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;
  }

  renderSortBy(parsedHTML) {
    const id = 'SortByContainer';
    if (document.getElementById(id) === null) return;

    document.getElementById(id).innerHTML = parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;
  }

  renderSortByMobile(parsedHTML) {
    const id = 'SortByContainerMobile';
    if (document.getElementById(id) === null) return;

    document.getElementById(id).innerHTML = parsedHTML.getElementById(id) && parsedHTML.getElementById(id).innerHTML;
  }
}
customElements.define('facet-form', FacetForm, { extends: 'form' });

class FacetRemove extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick);
  }

  onClick(event) {
    const form = this.closest('form[is="facet-form"]') || document.querySelector('form[is="facet-form"]');

    if (form) {
      event.preventDefault();

      const url = new URL(this.href);
      url.searchParams.set('section_id', FoxTheme.utils.getSectionId(form));
      form.renderSection(url.toString(), event);
    }
  }
}
customElements.define('facet-remove', FacetRemove, { extends: 'a' });

class FacetCount extends HTMLElement {
  constructor() {
    super();
  }

  facetUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.facetUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate,
      this.onFacetUpdate.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.facetUpdateUnsubscriber) {
      this.facetUpdateUnsubscriber();
    }
  }

  get itemCount() {
    return parseInt(this.innerText.replace(/\D/g, ''));
  }

  onFacetUpdate(event) {
    const parsedHTML = new DOMParser().parseFromString(event.responseText, 'text/html');
    const facetCount = parsedHTML.querySelector('facet-count');
    this.innerText = facetCount && facetCount.innerHTML;
    this.hidden = this.itemCount === 0;
  }
}
customElements.define('facet-count', FacetCount);

class FacetToggler extends HTMLButtonElement {
  constructor() {
    super();
    this.onClickHandler = this.onClick.bind(this);
  }

  connectedCallback() {
    this.facetEl = document.getElementById('FacetFiltersContainer');
    this.addEventListener('click', this.onClickHandler);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClickHandler);
  }

  onClick(evt) {
    evt.preventDefault();

    if (this.facetEl.classList.contains('xl:block')) {
      this.facetEl.classList.remove('xl:block');
    } else {
      this.facetEl.classList.add('xl:block');
    }
  }
}
customElements.define('facet-toggler', FacetToggler, { extends: 'button' });

class LoadMoreButton extends HTMLButtonElement {
  constructor() {
    super();
    this.onClickHandler = this.onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.onClickHandler);

    if (this.getAttribute('type') == 'infinite') {
      FoxTheme.Motion.inView(this, this.onClickHandler, { margin: '200px 0px 200px 0px' });
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClickHandler);
  }

  onClick() {
    if (this.classList.contains('btn--loading')) return;
    this.loadingState();

    const url = this.setUrl().toString();

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        this.renderPagination(responseText);
        this.renderProductGridContainer(responseText);
      });
  }

  renderPagination(responseText) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer === null) return;

    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
    const pagination = productGridContainer.querySelector('.pagination');
    const source = parsedHTML.querySelector('.pagination');

    if (source) {
      pagination.innerHTML = source.innerHTML;
    } else {
      pagination.remove();
    }
  }

  renderProductGridContainer(responseText) {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer === null) return;

    const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
    const productList = productGridContainer.querySelector('.products-list');
    const source = parsedHTML.querySelector('.products-list');

    if (source && productList) {
      source.querySelectorAll('.f-column').forEach((item) => {
        productList.appendChild(item);
      });
    }
  }

  setUrl() {
    const url = new URL(this.getAttribute('action'));
    url.searchParams.set('section_id', FoxTheme.utils.getSectionId(this));
    return url;
  }

  loadingState() {
    this.classList.add('pointer-events-none');
    this.classList.add('btn--loading');
  }
}
customElements.define('load-more-button', LoadMoreButton, { extends: 'button' });

class LayoutSwitcher extends HTMLElement {
  constructor() {
    super();
    this.cookieName = 'hypertheme:collection-layout';

    this.initLayoutMode();
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
  }

  get buttons() {
    return this.querySelectorAll('button');
  }

  /**
   * @param {event|element} evt
   */
  onButtonClick(evt) {
    const target = evt.currentTarget ? evt.currentTarget : evt;
    this.changeLayout(target, target.dataset.layoutMode);
  }

  initLayoutMode() {
    if (FoxTheme.config.hasLocalStorage) {
      const layoutMode = window.localStorage.getItem(this.cookieName);

      if (layoutMode !== null) {
        const target = this.querySelector(`button[data-layout-mode="${layoutMode}"]`);
        if (target) {
          this.changeLayout(target, layoutMode);
        }
      }
    }
  }

  changeLayout(target, layoutMode) {
    const productGrid = document.getElementById('ProductsList');
    if (!productGrid) return;

    productGrid.dataset.layout = layoutMode;

    const { gridClass, listClass } = productGrid.dataset;
    if ((gridClass || listClass) && gridClass !== listClass) {
      const productCards = productGrid.querySelectorAll('.product-card');
      productCards &&
        productCards.forEach((card) => {
          if ('grid' === layoutMode) {
            listClass && card.classList.remove(listClass);
            gridClass && card.classList.add(gridClass);
          } else {
            gridClass && card.classList.remove(gridClass);
            listClass && card.classList.add(listClass);
          }
        });
    }

    this.buttons.forEach((button) => {
      button.classList.remove('btn--active');
    });
    target.classList.add('btn--active');

    if (FoxTheme.config.hasLocalStorage) {
      window.localStorage.setItem(this.cookieName, layoutMode);
    }
  }
}
customElements.define('layout-switcher', LayoutSwitcher);

/* CASEMIRA: redirection si URL directe avec filtre dimension sans disponibilité */
(function() {
  var url = new URL(window.location.href);
  if (url.searchParams.has('filter.v.option.taille') && !url.searchParams.has('filter.v.availability')) {
    url.searchParams.set('filter.v.availability', '1');
    window.location.replace(url.toString());
  }
})(); 
/* CASEMIRA: corriger les compteurs du filtre Dimensions (stock réel uniquement) */
(function() {
  /* CASEMIRA C8 vague 4b · TROIS CHOSES ONT CHANGE ICI, ET UNE SEULE RAISON.
     Le groupe « Dimensions » du tiroir est desormais differe dans un `<template>`
     quand il ne porte aucune valeur active (voir le bloc « GROUPES DE FACETTES
     DIFFERES »). Or un `querySelectorAll` NE VOIT PAS le contenu d'un
     `<template>` : sans ces trois retouches, les compteurs corriges seraient
     appliques a la barre C6 mais PAS au tiroir, qui afficherait les compteurs
     bruts de Shopify. Ce serait une difference visible, donc un defaut.
       1. la lecture du HTML recu descend aussi dans les `<template>` ;
       2. l'application est extraite dans `appliquer(racine)` ;
       3. la derniere table est memorisee et rejouee a chaque deploiement. */
  var derniereTable = null;

  function champsTaille(racine) {
    var out = [];
    racine.querySelectorAll('input[name="filter.v.option.taille"]').forEach(function (i) { out.push(i); });
    racine.querySelectorAll('template[data-cm-facette]').forEach(function (t) {
      t.content.querySelectorAll('input[name="filter.v.option.taille"]').forEach(function (i) { out.push(i); });
    });
    return out;
  }

  function appliquer(table, racine) {
    if (!table) return;
    (racine || document).querySelectorAll('input[name="filter.v.option.taille"]').forEach(function(input) {
      var li = input.closest('li');
      if (!li) return;
      var countEl = li.querySelector('.count');
      if (!countEl) return;
      if (table.hasOwnProperty(input.value)) {
        countEl.textContent = table[input.value];
      } else {
        countEl.textContent = '0';
      }
    });
  }

  function updateDimensionCounts() {
    var form = document.querySelector('form[is="facet-form"]');
    if (!form) return;

    var url = new URL(window.location.href);
    url.searchParams.set('filter.v.availability', '1');
    url.searchParams.set('section_id', FoxTheme.utils.getSectionId(form));

    fetch(url.toString())
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var countMap = {};
        champsTaille(parsed).forEach(function(input) {
          var li = input.closest('li');
          if (li) {
            var countEl = li.querySelector('.count');
            if (countEl) countMap[input.value] = countEl.textContent.trim();
          }
        });

        derniereTable = countMap;
        appliquer(countMap, document);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateDimensionCounts);
  } else {
    updateDimensionCounts();
  }

  document.addEventListener('collection:rerendered', function() {
    setTimeout(updateDimensionCounts, 300);
  });

  /* Un groupe qui vient d'etre clone porte les compteurs bruts : on lui repose
     ceux du dernier relevé, dans la meme image. */
  document.addEventListener('casemira:facettes-deployees', function() {
    appliquer(derniereTable, document);
  });
})();